/**
 *
 * UpfrontTdr
 *
 */

import React, { memo } from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { Text } from '@cashfree-intl/coherent';
import {
  // Routes,
  // Route,
  // Outlet,
  useNavigate,
  useLocation,
  useSearchParams,
} from 'react-router-dom';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import Loader from 'components/Loader';
import makeSelectUpfrontTdr from './selectors';
import reducer from './reducer';
import saga from './saga';

import {
  getUpfrontTDRAction,
  enableLoaderAction,
  disableLoaderAction,
} from './actions';

import TDRList from './components/TDRList';
// import UpfrontTdrDetails from '../UpfrontTdrDetails';

type UpfrontTDR = {
  isLoading: boolean;
};

interface IUpfrontTdrProps {
  getUpfrontTDR: (data: any) => void;
  enableLoader: () => void;
  disableLoader: () => void;
  upfrontTdr: UpfrontTDR;
}

export function UpfrontTdr({
  getUpfrontTDR,
  enableLoader,
  disableLoader,
  upfrontTdr,
}: IUpfrontTdrProps) {
  useInjectReducer({ key: 'upfrontTdr', reducer });
  useInjectSaga({ key: 'upfrontTdr', saga, mode: '' });

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const { pathname } = location;
  const env = searchParams.get('env') || '';

  const { isLoading } = upfrontTdr;

  const setUpsertTDRDisplay = (data: any) => {
    navigate(
      `${pathname}/details?paymentMode=${data.paymentMethod}${
        env ? `&env=${env}` : ''
      }`,
    );
  };

  return (
    <div>
      <Loader active={isLoading} />
      <Text variant="b14" color="bodyLight" className="mb-4">
        Add and pass on TDR to your customers for each payment mode and manage
        them here.
      </Text>
      <TDRList
        displayTDRForm={setUpsertTDRDisplay}
        getUpfrontTDR={getUpfrontTDR}
        enableLoader={enableLoader}
        disableLoader={disableLoader}
        isLoading={isLoading}
      />
      {/* <Loader active={isLoading} />
      <Conditional if={!displayTDRForm}>
        <TDRList
          displayTDRForm={setUpsertTDRDisplay}
          getUpfrontTDR={getUpfrontTDR}
          enableLoader={enableLoader}
          disableLoader={disableLoader}
        />
      </Conditional>
      <Conditional if={displayTDRForm}>
        <UpsertTDRForm
          displayTDRForm={setUpsertTDRDisplay}
          getPaymentMethods={getPaymentMethods}
        />
        <TDRListPerPaymentMethod
          enableLoader={enableLoader}
          disableLoader={disableLoader}
          getUpfrontTDRPerPaymentMethods={getUpfrontTDRPerPaymentMethods}
        />
      </Conditional> */}
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  upfrontTdr: makeSelectUpfrontTdr(),
});

function mapDispatchToProps(dispatch) {
  return {
    getUpfrontTDR: data => dispatch(getUpfrontTDRAction(data)),
    enableLoader: () => dispatch(enableLoaderAction()),
    disableLoader: () => dispatch(disableLoaderAction()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(UpfrontTdr);
